import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { ProviderDiscountGetListRequest } from '@/api/request/providers-discounts/provider-discount-get-list.request';
import { GetGamesRequest } from '@/api/request/games/get-games.request';
import { BaseApi } from '@/api/base-api';
import {
  Game,
  GameResponse,
  PaginatedProviderDiscountResponse,
  ProviderDiscountCreate,
  ProviderDiscountResponse,
  ProviderDiscountUpdate,
  UpdateProviderDiscountCommentRequest,
} from '@/open-api/models';

export class ProvidersDiscountApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/providers-discounts';

  public getProvidersDiscounts(
    query: ProviderDiscountGetListRequest,
  ): Promise<PaginatedProviderDiscountResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/providers-discounts?${this.queryToQueryString(query)}`,
      {},
    );
  }

  public getProvidersDiscountsGames(
    query: GetGamesRequest,
  ): Promise<GameResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/dict/games?${this.queryToQueryString(query)}`,
      {},
    );
  }

  public getDictGame(id: string): Promise<Game> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/dict/games/${encodeURIComponent(id)}`,
      {},
    );
  }

  public createProviderDiscount(
    dto: ProviderDiscountCreate,
  ): Promise<ProviderDiscountResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[POST] /api/v1/providers-discounts`,
      dto,
    );
  }

  public updateProviderDiscount(
    id: number,
    dto: ProviderDiscountUpdate,
  ): Promise<ProviderDiscountResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PATCH] /api/v1/providers-discounts/${id}`,
      dto,
    );
  }

  public updateProviderDiscountComment(
    id: number,
    dto: UpdateProviderDiscountCommentRequest,
  ): Promise<ProviderDiscountResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PATCH] /api/v1/providers-discounts/${id}/comment`,
      dto,
    );
  }

  public deleteProviderDiscount(id: number): Promise<void> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[DELETE] /api/v1/providers-discounts/${id}`,
      {},
    );
  }
}
